export const STEPS = [
  {
    heading: 'На проверке',
    text: 'Может занимать до 3 дней, но обычно в течение дня',
  },
  {
    heading: 'Публикация',
    text: 'С этого момента отзыв виден на сайте',
  },
  {
    heading: 'Ответ',
    text: 'Организация или модератор подключаются к ситуации',
  },
  {
    heading: 'Решение проблемы',
    text: 'Компания может предложить решение',
  },
];
